var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "button-edit py-2 px-4"
  }, [_c('rich-text-input', {
    attrs: {
      "placeholder": _vm.$t('imageedit_enter_image_url'),
      "content": _vm.imageSrc,
      "mode": "url",
      "json": _vm.editorContentJson,
      "label": _vm.$t('imageedit_image_url')
    },
    on: {
      "update:content": function updateContent($event) {
        _vm.imageSrc = $event;
      },
      "update:json": function updateJson($event) {
        _vm.editorContentJson = $event;
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }